/* eslint-disable import/no-cycle */
import i18n from '../../i18n/i18n';
import {BaseWidgetConfig} from '../shared/widgets/baseWidgetConfig';
import WidgetSettingFormField from '../shared/widgets/WidgetSettingFormField';
import {SensorTypes} from '../../models/sensor';

export class OrderProgressWidgetConfig extends BaseWidgetConfig {
  // eslint-disable-next-line class-methods-use-this
  get tabs() {
    return [
      {
        key: 'settings',
        label: i18n.t('widget.WidgetSettingsModal.settingConfigTabTitle'),
      },
    ];
  }

  settings = [
    {
      id: 'sensor',
      label: `${i18n.t('orderProgressWidget.settings.sensor.label')}`,
      helpText: i18n.t('orderProgressWidget.settings.sensor.help'),
      options: this.rootStore.sensorStore.sensors
        .filter((sensor) => sensor.sensorType === SensorTypes.GoodsReceipt)
        .map((sensor) => ({value: sensor.name, label: sensor.label || sensor.name})),
      type: WidgetSettingFormField.fieldTypes.Select,
      allowClear: true,
    },
    {
      id: 'speed',
      label: `${i18n.t('orderProgressWidget.settings.speed.label')}`,
      helpText: i18n.t('orderProgressWidget.settings.speed.help'),
      options: [
        {value: 1000, label: i18n.t('orderProgressWidget.settings.speed.options.seconds')},
        {value: 60000, label: i18n.t('orderProgressWidget.settings.speed.options.minutes')},
        {value: 3600000, label: i18n.t('orderProgressWidget.settings.speed.options.hours')},
        {value: 144000000, label: i18n.t('orderProgressWidget.settings.speed.options.days')},
      ],
      type: WidgetSettingFormField.fieldTypes.Select,
      defaultValue: 1000,
      allowClear: true,
    },
    {
      id: 'actual',
      label: `${i18n.t('orderProgressWidget.settings.actual.label')}`,
      helpText: i18n.t('orderProgressWidget.settings.actual.help'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: 'Seconds',
    },
    {
      id: 'planned',
      label: `${i18n.t('orderProgressWidget.settings.planned.label')}`,
      helpText: i18n.t('orderProgressWidget.settings.planned.help'),
      type: WidgetSettingFormField.fieldTypes.Number,
      unit: 'Seconds',
    },
  ];
}
